import React from 'react'

//
import { ButtonGroup, ButtonNew, SectionHeader } from '../../../storybook'
import { ALIGN, HEADING_TYPE } from '../../../storybook/SectionHeader'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { useNavigationData } from '@/src/context/NavigationContext'

const BlockHero = ({ data: { title, description, primaryAction, secondaryAction } }) => {
  const location = React.useContext(LocationContext)
  const { navigationItems } = useNavigationData()
  const { slugPrefix } = location

  return (
    <section data-variant="narrow" className="l-section">
      <div className="l-container:8/12 l-container--default-spacing">
        <SectionHeader
          title={title || ''}
          text={description || ''}
          headingType={HEADING_TYPE.h1}
          align={ALIGN.center}
        >
          {(primaryAction || secondaryAction) && (
            <ButtonGroup center>
              {primaryAction && (
                <ButtonNew
                  url={getUrl({
                    navItem: primaryAction,
                    slugPrefix: slugPrefix,
                    navigationItems: navigationItems
                  })}
                  icon={primaryAction?.icon || ''}
                  subtext={primaryAction.subtext}
                  variant="green"
                >
                  {primaryAction?.title || ''}
                </ButtonNew>
              )}
              {secondaryAction && (
                <ButtonNew
                  url={getUrl({
                    navItem: secondaryAction,
                    slugPrefix: slugPrefix,
                    navigationItems: navigationItems
                  })}
                  icon={secondaryAction?.icon || ''}
                  variant="secondary"
                  subtext={secondaryAction.subtext}
                >
                  {secondaryAction?.title || ''}
                </ButtonNew>
              )}
            </ButtonGroup>
          )}
        </SectionHeader>
      </div>
    </section>
  )
}

export default BlockHero
